import React, { useContext } from "react";
import Modal from "react-modal";
import mondrian from "core/config/theme";
import Button from "components/Button";
import { useHistory } from "react-router-dom";
import { atributteFactory} from "core/Utils/Analytics/tagService";
import styled from "styled-components";
import { Heading } from "mondrian-react";
import { Text } from "mondrian-react";
import { store } from "store.js";
import sanitize from "core/Utils/SanitizeString";
import { TagTypeGa4 } from "core/Utils/Analytics/tagType";
import  TagAdapter from "core/Utils/Analytics/tagAdapter";
import tagAdapter from "core/Utils/Analytics/tagAdapter";
import { handleClick } from "components/Mondrian/Modal/Utils";
const ModalContent = styled.div`
  font-size: ${mondrian.fontSizeXs};
  .mdn-Heading {
    margin-bottom: 16px;
  }
`;

const MoldalHeader = styled.div`
  .mdn-Modal-header {
    padding-bottom: ${mondrian.spacingStackXs};
    padding-right: 25px;
  }
`;
const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  .mdn-Modal-footer {
    flex-wrap: wrap;
  }
  button {
    margin: 0 16px 16px 0;
  }
`;

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (process.env.NODE_ENV !== 'test') Modal.setAppElement("#root");
function callTagAdapter(options, currentFlow)  {
  if(currentFlow ==="customer2fa"){
  TagAdapter(options,TagTypeGa4.BUTTON_MODAL)
  }
}
export default function ({ content, ...props }) {
  let history = useHistory();
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { handleNext } = state.user;
  if (!content) return null;
  let { info, warning } = content;
  let modalContent = info || warning;
  if (!modalContent) return null;
  let { disableCloseButton, id: modalId, disableOnClickClose= false } = modalContent;
  const { title, message, instructions, buttons } = modalContent;
  const {currentFlow}  = state.analytics;
  function closeModal(e) {
    props.onClose && props.onClose();
  }
  const defaultConfig={nome_modal:title,type:TagTypeGa4.BUTTON_MODAL}

  let eventCategory = "minha-claro:meu-perfil";
  let eventAction = "clique-botao";
  let labelVoltar = sanitize(`modal:${modalId}:voltar`);
  let labelFechar = sanitize(`modal:${modalId}:fechar`);

  const atributteReturn =atributteFactory(currentFlow,eventCategory,eventAction,labelVoltar);
  const atributteClose =atributteFactory(currentFlow,eventCategory,eventAction,labelFechar);

  function getButtons(buttons = []) {
    const defaultCloseButton = (
      <Button
      {...atributteReturn}
      tagConfig={defaultConfig}
      onClick={closeModal}  
      >
        Voltar
      </Button>
    );
    if (!buttons.length && !disableCloseButton) {
      return defaultCloseButton;
    }

    function handleClick(event, onClick, redirect) {
      if (redirect) {
        closeModal();
        history.push(redirect);
      }

      if (onClick === true) {
        handleNext && handleNext();
      } else {
        onClick && onClick(event);
      }
      dispatch({
        type: "CLEAR_ERROR",
      });
      if(!disableOnClickClose)
      {
        closeModal();
      }
      
    }

    let arrButtons = buttons.map(
      (
        { action, label, onClick = action, redirect, ...buttonProps },
        index
      ) => {
        
        let labelButton = sanitize(`modal:${modalId}:${label}`);

        const atributteReturnButton =atributteFactory(currentFlow,eventCategory,eventAction,labelButton);

        return (
          <Button
            {...buttonProps}
            {...atributteReturnButton}
            tagConfig={defaultConfig}
            onClick={(ev) => {
              handleClick(ev, onClick, redirect);
            }
          }
          >
            {label}
          </Button>
        );
      }
    );

    return arrButtons;
  }
  return (
    <>
      <Modal
        isOpen={!!message}
        onRequestClose={closeModal}
        className="Modal"
        data-testid="modal-warning"
        overlayClassName="Overlay"
        contentLabel="Example Modal"
      >
        <div className="mdn-Modal mdn-isOpen">
          <div
            className="mdn-Modal-content"
            style={{ height: "auto", maxWidth: "600px", alignSelf: "center" }}
          >
            <MoldalHeader>
              <div className="mdn-Modal-header">
                {title && <Heading sm>{title}</Heading>}
                {!disableCloseButton &&
                <Button
                  className="mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondary"
                  {...atributteClose}
                  tagConfig={{nome_modal:'fechar',type:TagTypeGa4.BUTTON_MODAL}}
                  onClick={closeModal}  
                >
                  x
                </Button>
                }
              </div>
            </MoldalHeader>
            <div className="mdn-Divider mdn-Divider--primary"></div>
            <ModalContent>
              <div className="mdn-Modal-body">
                {message &&      <Text body>
                      <div
                        className="mdn-Text mdn-Text--body"
                        dangerouslySetInnerHTML={{ __html: message }}
                      ></div>
                    </Text>}
                {instructions && <Text body>{instructions}</Text>}
              </div>
              {
                <ModalFooter>
                  <div className="mdn-Modal-footer">{getButtons(buttons)}</div>
                </ModalFooter>
              }
            </ModalContent>
          </div>
        </div>
      </Modal>
    </>
  );
}
